// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__33-6g","inputWrap":"styles_inputWrap__rF8Ue","input":"styles_input__pS38M"};